export default "__VITE_ASSET__BJZO_Xlx__"